import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";
import { permanentRedirect } from "@/lib/legacyRedirects";

/** Gammal URL – permanent omdirigering (301). */
export const Route = createFileRoute("/hitta-natagare")({
  head: () => seoHead("/hitta-natagare"),
  beforeLoad: () => permanentRedirect("/verktyg/hitta-natagare"),
});
